import React from 'react';

import { Button } from '../Button/Button';

interface ModalProps {
  isOpen: boolean;
  title: string;
  body: string;
  cancelBtnTxt: string;
  confirmBtnTxt: string;
  onCancel: () => void;
  onConfirm: () => void;
}

const Modal: React.FC<ModalProps> = ({ isOpen, title, body, cancelBtnTxt, confirmBtnTxt, onCancel, onConfirm }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50">
      <div className="bg-white px-6 py-4 rounded-lg shadow-xl">
        <h4 className="text-custom-black w-full font-medium text-xl mb-2">{title}</h4>
        <p className="text-sm text-custom-darkSilver">{body}</p>

        <div className="flex justify-end gap-4 mt-8">
          <Button variant="transparent" onClick={onCancel}>
            {cancelBtnTxt}
          </Button>

          <Button variant="primary" onClick={onConfirm}>
            {confirmBtnTxt}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default Modal;
